module.exports = __webpack_public_path__ + "img/logo.f7fb3776.png";